module.exports = __webpack_public_path__ + "static/media/EasyWords_web_3.f5ba175a.jpg";